import React, { useState, useEffect, useCallback } from "react";
import {
  PopoverArrow,
  PopoverContent,
  Box,
  Stack,
  Icon,
  InputGroup,
  Input,
  LinkBox,
  LinkOverlay,
  Heading,
  Text,
  InputRightElement,
  Image,
  PopoverHeader,
  PopoverBody,
} from "@chakra-ui/react";
//import { SearchIcon } from "@chakra-ui/icons";
import { Markup } from "interweave";
import { Index } from "lunr";
import { MdKeyboardReturn } from "react-icons/md";
// import striptags from "striptags";

/*
const createIndex = (articles) => {
  const documents = [];
  const store = {};

  // Iterate over all articles
  articles.forEach((article) => {
    const { doi, versions } = article;
    const version = versions.filter((v) => v.decision === "publish")[0];
    const articleId =
      doi && doi.includes("/") && doi.split("/")[1].replace(/\./g, "-");
    if (version && articleId) {
      const {
        abstract,
        title,
        patternDescription: description,
        methods,
        reagents,
      } = version;
      store[articleId] = { title, excerpt: abstract || description };

      documents.push({
        slug: articleId,
        title: striptags(version.title),
        content: `${striptags(description)} ${striptags(methods)} ${striptags(
          reagents
        )}`,
        authors: version.authors
          .map((a) => `${a.firstName} ${a.lastName}`)
          .join(", "),
      });
    }
  });

  const index = lunr(function () {
    this.ref(`slug`);
    this.field(`title`);
    this.field(`content`);
    this.field(`authors`, { boost: 10 });

    documents.forEach((doc) => {
      this.add(doc);
    });
  });

  const json = { index: index.toJSON(), store };
  return json;
};
*/

const SearchModal = (props) => {
  const { initialFocusRef, lunrIndex } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setResults] = useState([]);

  const index = Index.load(lunrIndex.index);
  const searchData = useCallback(
    (e) => {
      // const { search } = this.state;
      setResults([]);

      console.log(e);
      console.log(searchTerm);

      const query = typeof e === "string" ? e : searchTerm;
      const results = index.search(query.replace("-", "\\-")).map(({ ref }) => {
        // Map search results to an array of {slug, title, excerpt} objects
        return {
          slug: ref,
          ...lunrIndex.store[ref],
        };
      });

      setResults(results);
      // setSearchTerm(e.target.value);
      // this.setState({ searchQuery: e.target.value, searchResults: queryResult });
    },
    [searchTerm, index, lunrIndex]
  );

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        setSearchTerm(event.target.value);
        searchData(event.target.value);
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [searchData]);
  /*
  const [lunrIndex, setIndex] = useState(null);

  const data = useStaticQuery(graphql`
    query {
      micropubApp {
        manuscripts(role: "editor", isPublished: true) {
          id
          doi
          versions {
            id
            abstract
            decision
            authors {
              firstName
              lastName
            }
            title
            patternDescription
            methods
            reagents
            image {
              url
            }
          }
        }
      }
    }
  `);
/*
  const articles = data.micropubApp.manuscripts
    .filter((manuscript) => manuscript.doi)
    .map((manuscript) => {
      const { doi, versions, id } = manuscript;
      const publishedVersion = head(
        versions.filter((version) => version.decision === "publish")
      );
      if (!publishedVersion) {
        return null;
      }

      const articleId =
        doi && doi.includes("/") && doi.split("/")[1].replace(/\./g, "-");

      const { title, authors, image } = publishedVersion;

      const authorString =
        authors &&
        authors
          .map((author) => `${author.firstName} ${author.lastName}`)
          .join(", ");

      // const thumbnail = `http://localhost:3000/api/export/${publishedVersion.id}/thumbnail`
      return {
        articleId: id,
        title,
        author: authorString,
        doi: articleId,
        figure: image.url,
      };
    })
    .filter((searchObject) => searchObject);
    */

  // if (!lunrIndex) {
  //  const index = createIndex(data.micropubApp.manuscripts)
  // setIndex(setIndex(Index.load(index.index))
  //`}

  const updateQuery = (e) => {
    console.log(e.target.value);
    setSearchTerm(e.target.value);
  };

  return (
    <PopoverContent>
      <PopoverArrow />
      <PopoverHeader>
        <InputGroup>
          <Input
            placeholder="Search microPublications..."
            id="Search"
            value={searchTerm}
            onChange={updateQuery}
            ref={initialFocusRef}
          />

          <InputRightElement
            cursor="pointer"
            onClick={searchData}
            children={<Icon as={MdKeyboardReturn} />}
          />
        </InputGroup>
      </PopoverHeader>
      <PopoverBody>
        <Box height="75vh" overflow="auto">
          <Box>Number of articles: {searchResults.length}</Box>
          <Stack>
            {searchResults.map((item) => {
              return (
                <LinkBox
                  as="article"
                  borderWidth="1px"
                  rounded="md"
                  _hover={{ border: "1px solid" }}
                >
                  <Image
                    src={item.image}
                    height="100px"
                    width="100%"
                    objectFit="cover"
                  />
                  <Box>
                    <Heading size="md" my="2">
                      <LinkOverlay href={`/journals/biology/${item.slug}`}>
                        <Markup content={item.title} />
                      </LinkOverlay>
                    </Heading>
                    <Text isTruncated>{item.authors}</Text>
                  </Box>
                </LinkBox>
              );
            })}
          </Stack>
        </Box>
      </PopoverBody>
    </PopoverContent>
  );
};

export default SearchModal;
